<template>
  <div class="popup">
    <div class="popup__container">
      <header class="popup__header">
        <h3 class="popup__title">{{ $t("errors.common.title") }}</h3>
        <div class="popup__header-button">
          <div class="close" @click.prevent="closePopup"></div>
        </div>
      </header>
      <div class="popup__content">
        <DefaultError />
      </div>
    </div>
  </div>
</template>

<script>
import DefaultError from "./blocks/DefaultError";

export default {
  components: {
    DefaultError,
  },
  props: {
    errorData: Object,
  },
  methods: {
    closePopup() {
      this.$store.commit("server_error/closeErrorPopup");
      window.location.reload();
    },
  },
};
</script>
